import { render, staticRenderFns } from "./decorate.vue?vue&type=template&id=cfa71b38&scoped=true"
import script from "./decorate.vue?vue&type=script&lang=ts"
export * from "./decorate.vue?vue&type=script&lang=ts"
import style0 from "./decorate.vue?vue&type=style&index=0&id=cfa71b38&prod&lang=less&scoped=true"
import style1 from "./decorate.vue?vue&type=style&index=1&id=cfa71b38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa71b38",
  null
  
)

export default component.exports